//_INDEX.REDUCERS.JS
//Liste de tout les objets manipulés dans l'application

/**
 * COMMENT STRUCTURER LES ACTIONS
 * 

# Convention de nommage pour une action
<reducer><action><attribut?>

# REDUCER => objet à modifier
ex : filter, account

# ACTION => quel opération réaliser sur l'objet
ex filterActivate, accountGet

=== liste des actions possibles ===
activate => sélectionner une ligne pour la rendre active
add => créer une ligne côté front
cancel => annuler une opération
copy => ajouter un user dans la liste à partir d'une liste existante
duplicate => créer un enregistrement en BDD à partir d'un enregistrement actuel
edit => modifier l’enregistrement actif côté front
destroy => supprimer une ligne dans la BDD
fetch => récupérer la liste des utilisateurs dans la BDD
get => mettre à jour la liste côté front
init => initialiser le store
insert => créer une ligne dans la BDD
remove => supprimer une ligne côté front
replace => remplace an item by another one wich the same id
save => sauvegarder les modifications côté front
status => définir le statut
update => mettre à jour la ligne dans la BDD
upload => uploader une image sur le serveur

# ATTRIBUT => paramètre optionnel sur l'action
ex : filterEditName, accountGet_AsSupervisor


*/

import roles from "@/redux/role.reducers"
import storage from "redux-persist/lib/storage"
import { persistReducer } from "redux-persist"
import { configureStore } from "@reduxjs/toolkit"
import { combineReducers } from "redux"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import apiMiddleware from "@/utils/api-middleware.utils"
import _session from "../redux/_session.reducers"
import account from "../redux/account.reducers"
import actionPlan from "../redux/action-plan.reducers"
import attribute from "../redux/attribute.reducers"
import axis from "../redux/axis.reducers"
import bookmark from "../redux/bookmark.reducers"
import email from "../redux/email.reducers"
import filter from "../redux/filter.reducers"
import invitation from "../redux/invitation.reducers"
import learning from "../redux/learning.reducers"
import lesson from "../redux/lesson.reducers"
import message from "../redux/message.reducers"
import page from "../redux/page.reducers"
import project from "../redux/project.reducers"
import proposition from "../redux/proposition.reducers"
import question from "../redux/question.reducers"
import regrouping from "../redux/regrouping.reducers"
import reminder from "../redux/reminder.reducers"
import report from "../redux/report.reducers"
import unitStore from "@/features/risks/entities/unit/model/unit.store"
import sending from "../redux/sending.reducers"
import subscription from "../redux/subscription.reducers"
import survey from "../redux/survey.reducers"
import template from "../redux/template.reducers"
import topic from "../redux/topic.reducers"
import user from "../redux/user.reducers"
import riskStore from "@/features/risks/entities/risk/model/risk.store"
import jobStore from "@/features/risks/entities/job/model/job.store"
import establishmentStore from "@/features/adm/entities/establishment/model/establishment.store"
import organizationStore from "@/features/adm/entities/organization/model/organization.store"
import recipientsView from "@/features/survey/entities/recipients-view/recipients-view.store"
const rootReducer = combineReducers({
  _session,
  roles,
  account,
  actionPlan,
  attribute,
  axis,
  bookmark,
  email,
  filter,
  invitation,
  learning,
  lesson,
  message,
  page,
  project,
  proposition,
  question,
  regrouping,
  reminder,
  report,
  sending,
  subscription,
  survey,
  template,
  topic,
  user,
  risk: riskStore._reducer,
  job: jobStore._reducer,
  unit: unitStore._reducer,
  establishment: establishmentStore._reducer,
  organization: organizationStore._reducer,
  recipientsView
})

const persistConfig = {
  key: "root",
  blacklist: ["roles", "recipientsView"],
  storage
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }).concat(apiMiddleware)
})

// Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>
export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
